<fieldset [ngClass]="{'form-group': append}">
  @if (label) {
    <label [raskRequired]="required">
      {{label}}
      @if (infoText) {
        <rask-info>{{infoText}}</rask-info>
      }
    </label>
  }
  <div [ngClass]="{'input-group': append}">
    @if (!showCustomInput) {
      <input
        #input [ngClass]="{'readonly': readonly, 'form-control': append}" id="{{aid}}" [(ngModel)]="value"
        [ngModelOptions]="{standalone: true}"
        [placeholder]="placeholder" [disabled]="disabled || readonly" type="{{type}}" [attr.maxlength]="maxlength">
    } @else {
      <input #input [ngClass]="{'readonly': readonly, 'form-control': append}" id="{{aid}}"
        [(ngModel)]="customValue" (ngModelChange)="customValueChange($event)"
        [ngModelOptions]="{updateOn: updateOn, standalone: true}"
        [placeholder]="placeholder" [disabled]="disabled || readonly" type="{{type}}"
        [attr.maxlength]="maxlength">
      }

      @if (append) {
        <ng-content class="input-group-append" selector=".rask-input-append"></ng-content>
      }
      <ng-content select="[appendContent]"></ng-content>
      @if (showmaxlength && maxlength > 0) {
        <div class="input-chars">
          <span class="remaining">{{texts.charsLeft | raskStringFormat : charsLeft}}</span>
        </div>
      }
      @if (rule) {
        <rask-validation-message [rule]="rule"></rask-validation-message>
      }
    </div>
  </fieldset>